<template lang="html">
  <div class="donautocomplete">
    <div class="donautocomplete-input-group" v-bind:class="{'donautocomplete-selected': value}">
      <input type="text" v-model="searchText" v-bind="inputAttrs"
             class="donInputsEffect"
             v-bind:class="inputAttrs.class || inputClass"
             :placeholder="inputAttrs.placeholder || placeholder"
             v-bind:disabled="inputAttrs.disabled || disabled"
             @blur="blur" @focus="focus" @input="inputChange"
             @keyup.enter="keyEnter" @keydown.tab="keyEnter"
             @keydown.up="keyUp" @keydown.down="keyDown" required autocomplete="off">
      <label class="donInputsEffectLabels"
             v-bind:class="inputAttrs.classLabel"
             :for="inputAttrs.id">{{ inputAttrs.datalabel }}</label>

    </div>
    <div class="donautocomplete-list" v-if="show">
      <div class="donautocomplete-list-item" v-for="item, i in internalItems" @click="onClickItem(item)"
           v-bind:class="{'donautocomplete-item-active': i === cursor}" @mouseover="cursor = i">

        <div :is="componentItem" :item="item" :searchText="searchText"></div>
      </div>
    </div>
  </div>
</template>
<script>
  /* Ejemplo
        donautocomplete(:items="items"
              v-model='item',
              :get-label='getLabel',
              :min-len='0'
              :component-item='tpl',
              @filter-items='update',
              @item-selected="itemSelected",
              @item-clicked="itemClicked",
              :input-attrs="{name: 'input-test', id: 'v-my-autocomplete'}")


        ******************************************************************************************************************

        import Autocomplete from '../src/Autocomplete.vue'
        import tpl from './TplItem.vue' **** Otro template ****
        import Animals from './animals.js'
        export default {
          name: 'demo',
          components: {'donautocomplete': Autocomplete},
          data () {
            return {
              itemsApi: [],
              item: {id: 9, name: 'Lion', description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
              items: [],
              tpl: tpl
            }
          },
          methods: {
            itemSelected (item) {
              console.log('Selected item!', item)
            },
            itemClicked (item) {
              console.log('You clicked an item!', item)
            },
            getLabel (item) {
              if (item) {
                return item.name
              }

              return ''
            },
            update (text) {
              this.items = Animals.filter((item) => {
                return (new RegExp(text.toLowerCase())).test(item.name.toLowerCase())
              })
            }
          }
        }

   * */
  import Item from './don.item'
  import utils from './autocomplete'

  export default {
    name: 'donautocomplete',
    props: {
      componentItem: { default: () => Item },
      minLen: { type: Number, default: utils.minLen },
      wait: { type: Number, default: utils.wait },
      value: null,
      //getLabel: {
      //  type: Function,
      //  default: item => item
      //},
      getEmpty: {
        type: Function,
        default: item => item
      },
      labelItem: { type: String, default: "description" },
      items: Array,
      autoSelectOneItem: { type: Boolean, default: true },
      placeholder: String,
      inputClass: { type: String, default: 'donautocomplete-input' },
      disabled: { type: Boolean, default: false },
      inputAttrs: { type: Object, default: () => { return {} } },
      keepOpen: { type: Boolean, default: false },
      cliente: { type: Boolean, default: true },
    },
    data() {
      return {
        searchText: '',
        showList: false,
        cursor: -1,
        internalItems: this.items || []
      }
    },
    computed: {
      hasItems() {
        return !!this.internalItems.length
      },
      show() {
        return (this.showList && this.hasItems) || this.keepOpen
      }
    },
    methods: {
      inputChange() {
        this.showList = true
        this.cursor = -1
        this.onSelectItem(null, 'inputChange')
        utils.callUpdateItems(this.searchText, this.updateItems)
        this.$emit('change', this.searchText)
      },

      updateItems() {
        this.$emit('filter-items', this.searchText)
      },

      focus() {
        this.$emit('focus', this.searchText)
        this.showList = true
      },

      blur() {
        this.$emit('blur', this.searchText)
        setTimeout(() => this.showList = false, 200)
      },

      onClickItem(item) {
        this.onSelectItem(item)
        this.$emit('item-clicked', item)
      },

      onSelectItem(item) {
        if (item) {
          this.internalItems = [item]
          this.searchText = item[this.labelItem]
          this.$emit('item-selected', item)
        } else {
          this.setItems(this.items)
        }

        if (item) {
          this.$emit('input', item);
        } else {
          this.$emit('input', { id: 0, description: this.searchText });
        }
      },

      setItems(items) {
        this.internalItems = items || []
      },

      isSelectedValue(value) {
        return 1 == this.internalItems.length && value == this.internalItems[0]
      },

      keyUp(e) {
        if (this.cursor > -1) {
          this.cursor--
          this.itemView(this.$el.getElementsByClassName('donautocomplete-list-item')[this.cursor])
        }
      },

      keyDown(e) {
        if (this.cursor < this.internalItems.length) {
          this.cursor++
          this.itemView(this.$el.getElementsByClassName('donautocomplete-list-item')[this.cursor])
        }
      },

      itemView(item) {
        if (item && item.scrollIntoView) {
          item.scrollIntoView(false)
        }
      },

      keyEnter(e) {
        if (this.showList && this.internalItems[this.cursor]) {
          this.onSelectItem(this.internalItems[this.cursor])
          this.showList = false
        }
      },

    },
    created() {
      utils.minLen = this.minLen
      utils.wait = this.wait
      this.onSelectItem(this.value)
    },
    watch: {
      items(newValue) {
        this.setItems(newValue)
        let item = utils.findItem(this.items, this.searchText, this.autoSelectOneItem)
        if (item) {
          this.onSelectItem(item)
          this.showList = false
        }
      },
      value(newValue) {
        if (!this.isSelectedValue(newValue)) {
          this.onSelectItem(newValue)
          this.searchText = newValue[this.labelItem]
          this.$emit('change', this.searchText)
        }
      }
    }
  }
</script>
<style>

  .donautocomplete {
    position: relative;
    text-align: left;
  }

    .donautocomplete .donautocomplete-list {
      position: absolute;
      z-index: 9999;
      background-color: white;
      max-height: 250px;
      overflow: auto;
      width: 100%;
      border: 1px solid #ccc;
      border-radius: 3px;
    }

      .donautocomplete .donautocomplete-list .donautocomplete-list-item {
        cursor: pointer;
      }

        .donautocomplete .donautocomplete-list .donautocomplete-list-item.donautocomplete-item-active {
          color: white;
          background-color: var(--primaryColor);
        }
</style>



// WEBPACK FOOTER //
// src/componentes/global/autocomplete/don.autocomplete.vue